// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

// Available solution actions
export const COPILOT_STATUS = {
  IDLE: 'IDLE',
  WAITING: 'WAITING',
  READY: 'READY',
  ERROR: 'ERROR',
};

export const COPILOT_ACTIONS_KEY = {
  GET_COPILOT_TOKEN: 'GET_COPILOT_TOKEN',
  SET_COPILOT_TOKEN: 'SET_COPILOT_TOKEN',
};
